import { Modal as MuiModal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export enum ModalSizes {
  small = "small",
  default = "default",
  medium = "medium",
  large = "large",
  extraLarge = "extraLarge",
}

export default function Modal({
  children,
  isOpen,
  closeModal,
  height = "",
  size = "default",
}) {
  return (
    <MuiModal open={isOpen} onClose={(event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
      }
      closeModal();
    }}>
      <Box
        sx={{
          width: size === "extraLarge" ? 1200 : size === "lg" ? 800 : size === "sm" ? 400 : 600,
          maxHeight: height !== "" ? height : "90vh",
          overflowY: "auto",
          backgroundColor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          mx: "auto",
          my: "5%",
          position: "relative",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={closeModal}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        {children}
      </Box>
    </MuiModal>
  );
}
